import {
  Component,
  OnInit
} from "@angular/core";
import { UnidadesService } from "src/app/views/recepcion/unidades/unidades.service";

@Component({
  selector: "app-modal-search-unit",
  templateUrl: "./modal.component.html",
})
export class SearchUnitModal implements OnInit {
  public _filter = "";
  public status: { Id: string; Desc: string }[] = [
    { Id: "R", Desc: "Trabajando  " },
    { Id: "A", Desc: "En tramite" },
    { Id: "T", Desc: "Taller" },
    { Id: "Y", Desc: "Yarda" },
  ];

  public data: any[] = [];
  public dataShow: any[] = [];

  constructor(private service: UnidadesService) {}
  public ngOnInit() {
    this.getUnidades();
  }

  private getUnidades() {
    this.service.get().subscribe((next) => {
      let EstadoDesc = "";
      this.data = next
        .filter((f) => f.Activo)
        .map((m) => {
          EstadoDesc =
            this.status.find((f) => f.Id == m.Estado)?.Desc ?? "DESCONOCIDO";
          return {
            Chofer: m.Chofer,
            Estado: m.Estado,
            Modelo: m.Modelo,
            NoControl: m.NoControl,
            Placas: m.Placas,
            Serie: m.Serie,
            Supervisor: m.Supervisor,
            TipoUnidad: m.TipoUnidad,
            NumeroMotor: m.NumeroMotor,
            EstadoDesc,
          };
        });
    });
  }
  onFilter() {
    let filterdata = this.data;

    const filtro = this._filter.toLocaleLowerCase().trim();
    if (filtro.length > 0) {
      const temp: ((o: any, f: string) => boolean)[] = [
        (o, f) => (o.Chofer ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.EstadoDesc ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.Modelo ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.NoControl ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.Placas ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.Serie ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.Supervisor ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.TipoUnidad ?? "").toLocaleLowerCase().indexOf(f) > -1,
        (o, f) => (o.NumeroMotor ?? "").toLocaleLowerCase().indexOf(f) > -1,
      ];
      filterdata = filterdata.filter((f) => temp.some((c) => c(f, filtro)));
      this.dataShow = filterdata;
    } else {
      this.dataShow = [];
    }
  }
}
